import React from 'react';
import ReactDom from 'react-dom';
import Dict from 'dict-lib';
import {LexemeUtilities, getContextTypes, LexemeEditingLevel, LexemePageInfos} from './../../../editor/LexemeHelper';
import {setPolyForm, setNoNeedForSeeEntry} from './../../../editor/entry/EntryActions';
import {Button, Glyphicon, Popover, OverlayTrigger, InputGroup, FormControl, Col} from 'react-bootstrap';
import {openModal} from './../LexemePolyrhematics';
import './../LexemePolyrhematics.css';
import './../../../../../_css/lexeme.css';
import {LexemeSubentries} from './../../03_Subentries/LexemeSubentries';
import {LexemeReferences} from './../../05_References/LexemeReferences';
import {getLexemeOptions} from './../../../LexemePage';
import {LexemePageContext} from "../../../LexemePageContext";

import stylesPolyrhematic from './../../../../../_css/dictionary/lexemeParts/lexemePolyrhematic.module.css';
import stylesLexemeEditor from './../../../../../_css/dictionary/lexemeEditor.module.css';
import BUtils from './../../../../../utilities/BaseUtilities';
import stylesLexemeTitle from "../../../../../_css/dictionary/lexemeParts/lexemeTitle.module.css";
import stylesScNavbar from "../../../../../dict-components/navbar/ScNavbar.module.css";
import ReactTooltip from "react-tooltip";

export class LexemePolyrhematic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            name: "POLYRHEMATIC_TITLE",
            item: "POLYRHEMATIC",
            ids: this.props.ids,
            isActive: false,
            noNeedForActive: this.props.no_need_for_see_entry
        };

        this.polyForms = [];
        this.isMobile = BUtils.isMobile();

        this._openModalPoly = this._openModalPoly.bind(this);
        this._isActive = this._isActive.bind(this);
        this._handleClick = this._handleClick.bind(this);
    }

    /*componentWillMount() {
        this.setState({noNeedForActive: true});
    }*/

    _openModalPoly() {
        this.props.callbackParent(this.props.order);
    }

    _polyFormClick(item) {
        var id = "id-popover-edit-polies";
        if (LexemeUtilities.isPageEditable(this)) {
            var myDefabs = this.polyForms.slice(0);
            return <Popover /*{...this.props}*/ className={"popover-edit-text"} id={id}
                                                key={"key-popover-edit-polies"}>
                <EditPoly defabs={myDefabs} item={item}
                          callbackParent={(newState) => this.props.callbackParent()}/>
            </Popover>;
        } else
            return LexemeUtilities.getHiddenPopover(id);
    }

    _isActive() {
        return this.state.isActive ? "lexTranslatableActive" : "";
    }

    _handleClick(isTranslatorSelector) {
        if (isTranslatorSelector) {
            if(LexemeUtilities.foundExternalCreateEnvironment())
                LexemeUtilities.resetExternalPopovers('lex-poly-button-bar');
            LexemeUtilities.handleClick(this);

            this.setState({isActive: !this.state.isActive});
        }
    }

    _isEmpty(description) {
        return description.replace(/-/g, '').replace('(', '').replace(')', '').trim().length === 0 ? 'emptyAbs' : "";
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.noNeedForActive !== nextState.noNeedForActive;
    }


    render() {
        const isTranslatorSelector = LexemeUtilities.isTranslationSelector(this);
        const isReadOnlyCreatable = LexemeUtilities.isReadOnlyCreate(this);
        var polyStyle = LexemePageInfos.getLexemeOptions(this.context, this.props.hasDash === true ? "poly_style_in_xml" : 'poly_bracket_style_in_xml');
        const additionalPolyClass = typeof polyStyle !== 'undefined' ? polyStyle.toLowerCase() : '';
        const hasExternalMono = typeof this.props.inverse_references.external_poly !== 'undefined' && this.props.inverse_references.external_poly.length > 0;
        const noNeedForActive = this.state.noNeedForActive;
        const showAnomalyNoNeedForSeeEntry = !this.props.readonly && !hasExternalMono /*&& !noNeedForActive*/;
        const showOrder = this.props.showOrder;

        return <>
            <Col lg={1} md={1} className={stylesPolyrhematic['lexeme-poly-edit']}>
                {isTranslatorSelector || isReadOnlyCreatable || this.isMobile ? '' : <Button
                    bsStyle="primary"
                    bsSize="xsmall"
                    bsClass={LexemeUtilities.isReadOnly(this) || this.props.readonly ? "lexemeVisibilityHidden" : "btn btn-xs btn-primary"}
                    onClick={this._openModalPoly}
                >
                    <Glyphicon glyph="new-window"/>
                    <Glyphicon glyph="triangle-right"/>
                    <Glyphicon glyph="triangle-right"/>
                </Button>}
            </Col>
            <Col id={'lexeme-polyrhematic-' + this.props.ids} lg={11} md={11}
                 data-tip
                 data-for={'lexmeReadOnlyPolyrhematic' + this.props.ids}
                 className={BUtils.joinClasses(stylesPolyrhematic['lexeme-polyrhematic'], stylesPolyrhematic['lexeme-polyrhematic--' + (this.props.is_hidden ? "hidden" : "show")], stylesPolyrhematic['lexeme-polyrhematic-readonly--' + this.props.readonly])}>
                <Col lg={4} md={4} className={stylesPolyrhematic['lexeme-polyrhematic-col']}>
                    {showAnomalyNoNeedForSeeEntry ? <div className={stylesPolyrhematic['poly-alert-external-mono']}>
                        <Glyphicon glyph={'alert'} data-tip
                                   data-for={'AlertNoNeedSeeEntry-' + this.props.ids}
                                   className={BUtils.joinClasses(stylesPolyrhematic['glyph-poly-alert-external-mono'], stylesPolyrhematic['glyph-poly-alert-external-mono-active--' + noNeedForActive])}
                                   onClick={() => {
                                       var newNoNeedForActive = !this.state.noNeedForActive;
                                       this.setState({noNeedForActive: newNoNeedForActive},
                                           () => {
                                               setNoNeedForSeeEntry(this.props.ids, newNoNeedForActive);
                                           }
                                       );
                                   }
                                   }
                        />
                        <ReactTooltip id={'AlertNoNeedSeeEntry-' + this.props.ids} type='info' delayShow={20}
                                      className={stylesPolyrhematic['poly-no-need-tooltip']}>
                            <span>{Dict.t(noNeedForActive ? 'ALERT_EXTERNAL_MONO_MISSING' : 'SET_EXTERNAL_MONO_MISSING')}</span>
                        </ReactTooltip>
                    </div> : ''}
                    {this.props.readonly ?
                        <ReactTooltip id={'lexmeReadOnlyPolyrhematic' + this.props.ids} type='info' delayShow={300}
                                      className={stylesPolyrhematic['poly-no-need-tooltip']}>
                            <span>{Dict.t('EXTERNAL_POLY_FROM_LEXEME')}</span>
                            <strong>{' ' + this.props.mono_form}</strong>
                        </ReactTooltip> : ''}
                    <div className={BUtils.joinClasses(stylesPolyrhematic['poly-order'], stylesPolyrhematic['poly-order__show--' + showOrder])}>{this.props.order + 1}</div>
                    {this.context.pageStatus === LexemeEditingLevel.EDITABLE ?
                        <div
                            className={BUtils.joinClasses(stylesLexemeTitle['lexeme-status'], stylesPolyrhematic['poly-status'], stylesLexemeTitle['lexeme-status--' + this.props.status])}>&nbsp;</div> : ""}
                    <OverlayTrigger
                        rootClose={true}
                        key={"key-overlay-sense-" + this.props.ids}
                        trigger={this.props.readonly ? '' : 'click'}
                        placement="right"
                        /*container={document.getElementById("modal-poly-edit")}*/
                        overlay={isTranslatorSelector || isReadOnlyCreatable ? LexemeUtilities.createButtonBarTooltip(this) : this._polyFormClick(this.props)}
                    >
                        <div ref="polyFormRef" data-has-dash={this.props.hasDash}
                             onClick={(event) => {
                                 if (!this.props.readonly)
                                     this._handleClick(isTranslatorSelector || isReadOnlyCreatable)
                             }}
                             className={'lexHighlightable ' + stylesPolyrhematic['lexeme-poly-form'] + ' ' + (isTranslatorSelector || isReadOnlyCreatable ? LexemeUtilities.getLexClass(this) + " " + this._isActive() : (this.props.readonly ? '' : LexemeUtilities.getLexTextClass(this))) + " " + additionalPolyClass + " " + this._isEmpty(this.props.html_form)}
                             dangerouslySetInnerHTML={{__html: this.props.html_form}}/>
                    </OverlayTrigger>
                </Col>
                <Col lg={8} md={8}>
                    <div className={stylesPolyrhematic['lexeme-polyrhematic-subentry']}>
                        <LexemeSubentries isPolyFromLexeme={true} page={this.props}/>
                    </div>
                    {Object.keys(this.props.references).length > 0 ?
                        <LexemeReferences isPolyFromLexeme={true} direct={true} page={this.props}/> : ""}
                    {Object.keys(this.props.inverse_references).length > 0 ?
                        <LexemeReferences isPolyFromLexeme={true} direct={false} page={this.props}/> : ""}
                </Col>
            </Col>
        </>;
    }
}

class EditPoly extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            description: this.props.item.striked_form,
            showComponent: true,
            defabs: this.props.defabs
        };

        this.textExist = false;

        this._handlePolyForm = this._handlePolyForm.bind(this);
        this._handleKeyUp = this._handleKeyUp.bind(this);
    }

    componentWillMount() {
        if (document.getElementById("lex-sense-button-bar")) {
            document.getElementById("lex-sense-button-bar").classList.remove("in");
        }
    }

    componentDidMount() {
        var x = window.scrollX, y = window.scrollY;
        ReactDom.findDOMNode(this.senseAbs).focus();
        ReactDom.findDOMNode(this.senseAbs).value = "";
        ReactDom.findDOMNode(this.senseAbs).value = this.state.description;
        window.scrollTo(x, y);
        /*setTimeout(function () {
         document.getElementById("lex-sense-button-bar").classList.remove("in");
         }, 0);*/
    }


    _handlePolyForm(evt) {
        this.textExist = evt.target.value.trim().length > 0 && (evt.target.value.toLowerCase() !== this.props.item.striked_form.toLowerCase() && this.props.defabs.indexOf(evt.target.value.toLowerCase()) > -1);
        this.setState({description: evt.target.value});
    }

    _handleKeyUp(evt) {
        if (evt.keyCode === 13) {
            /*if (this.textExist) {
                LexemeUtilities.showModalMessage("error", Dict.t('SENSE_ABS_FOUND'), 2000);
            } else {*/
            setPolyForm(this.props.item.ids, this.state.description);
            this._handleClose();
            //}
        } else if (evt.keyCode === 27) {
            //this.props.callbackParent();
            this._handleClose();
        }
    }

    _handleClose() {
        var el = document.getElementsByClassName("popover-edit-text")[0];
        el.classList.add("popover-edit-text-fade-out");

        const lexSense = document.getElementsByClassName('lexemeSenses')[0]
        if(lexSense) {
            setTimeout(function () {
                document.getElementsByClassName('lexemeSenses')[0].click();
            }.bind(this), 400);
        }
    }

    render() {

        var length = (this.state.description + "").length;
        var width = 200 * (parseInt(length / 26) + 1) + 20;

        return <div ref={"poliEditContainer"} id="poli-edit-container-id"
                    className={this.state.showComponent ? "sense-edit-container " : "sense-edit-hide"}
        >
            <InputGroup className={"sense-edit " + ""}><FormControl style={{width: width}}
                                                                    type="text"
                                                                    placeholder={this.props.description}
                                                                    ref={(input) => {
                                                                        this.senseAbs = input;
                                                                    }}
                                                                    value={this.state.description}
                                                                    onChange={(evt) => this._handlePolyForm(evt)}
                                                                    onKeyUp={this._handleKeyUp}/>
            </InputGroup>
        </div>
    }
}

LexemePolyrhematic.contextType = LexemePageContext;

